// eslint-disable-next-line import/prefer-default-export
export const { VITE_PORTAL_API, VITE_ENVIRONMENT } = import.meta.env;
// export const {
//   VITE_BSO_PORTAL_API
// } = import.meta.env;
// export const VITE_BUILD_VERSION = '2.0.3';
